import { Box, BoxProps, Divider, VStack } from '@chakra-ui/react';
import { useRemoveLineItem, type Cart } from '@ifixit/shopify-cart-sdk';
import type { ElementType } from 'react';
import { CartLineItem } from './drawer/CartLineItem';
import type { CartImageComponent } from './types';

export type CartLineItemsProps = BoxProps & {
   cart: Cart;
   testIdPrefix: string;
   ImageComponent: CartImageComponent;
   linkComponent?: ElementType;
   localeCode: string;
   formatDiscountLabel: (discount: number) => string;
   translations: {
      unableToRemoveProduct: string;
      tryActionAgain: string;
   };
   updateCartTranslations: {
      ariaDecrease: string;
      ariaIncrease: string;
      notEnoughInventory: string;
      outOfStock: string;
      unableToUpdateQuantity: string;
   };
};

export function CartLineItems({
   cart,
   testIdPrefix,
   ImageComponent,
   linkComponent,
   localeCode,
   formatDiscountLabel,
   translations,
   updateCartTranslations,
   ...otherProps
}: CartLineItemsProps) {
   const { removeLineItem, enabled: removeLineItemEnabled } = useRemoveLineItem({ translations });

   return (
      <Box data-testid={`${testIdPrefix}-line-items`} {...otherProps}>
         <VStack spacing="0" align="stretch" divider={<Divider />} listStyleType="none">
            {cart.lineItems.map(item => (
               <CartLineItem
                  key={item.itemcode}
                  lineItem={item}
                  onRemove={() => removeLineItem.mutate({ line: item })}
                  removeDisabled={!removeLineItemEnabled}
                  ImageComponent={ImageComponent}
                  linkComponent={linkComponent}
                  localeCode={localeCode}
                  formatDiscountLabel={formatDiscountLabel}
                  {...updateCartTranslations}
               />
            ))}
         </VStack>
      </Box>
   );
}
